import { render, staticRenderFns } from "./provider-employee-training-records.vue?vue&type=template&id=02737a9b&scoped=true"
import script from "./provider-employee-training-records.vue?vue&type=script&lang=js"
export * from "./provider-employee-training-records.vue?vue&type=script&lang=js"
import style0 from "./provider-employee-training-records.vue?vue&type=style&index=0&id=02737a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02737a9b",
  null
  
)

export default component.exports